<template>
  <!-- 查看报名人员对话框 -->
  <el-dialog
    title="查看报名人员"
    :visible.sync="show"
    :before-close="closeDialog"
    width="80%"
  >
    <div style="width: 95%; margin: 0 auto">
      <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
        <!-- <el-tab-pane name="" @click="handleClick">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane> -->

        <el-tab-pane name="1" @click="handleClick">
          <span slot="label" class="table-title">参加人员</span>
        </el-tab-pane>
        <el-tab-pane name="2" @click="handleClick">
          <span slot="label" class="table-title">被拒人员</span>
        </el-tab-pane>
      </el-tabs>

      <div>
        <div class="handle-box-search">
          <div class="handle-box">
            <el-row class="head-search">
              <el-col :span="24">
                <span>姓名 </span>
                <el-input
                  v-model="search_data_children.name"
                  placeholder="请输入姓名"
                  maxlength="11"
                  style="width: 340px"
                  @keyup.enter.native="searchJoinTaskDriverList"
                ></el-input>
              </el-col>
            </el-row>
          </div>
          <el-button @click="searchJoinTaskDriverList">搜索</el-button>
          <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
          <el-button icon="el-icon-setting" @click="toExport" v-else
            >导出</el-button
          >
        </div>
      </div>

      <!-- 参加人员表格 -->
      <el-table
        v-if="activeName == '1'"
        :data="tableData"
        max-height="500"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="driver_name" label="姓名"> </el-table-column>
        <el-table-column prop="" label="奖励">
          <template slot-scope="scope">
            <div>
            {{scope.row.reward_monitor? "表现分:"+Number(scope.row.reward_monitor): ''}}
            </div>
            <div>
            {{scope.row.reward_amount?"现金:"+Number(scope.row.reward_amount):''}}
            </div>
            <div>
            {{scope.row.reward_priority_num?"优享券:"+Number(scope.row.reward_priority_num):''}}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="time_stamp" label="推广日期"> </el-table-column>

        <el-table-column prop="give_stamp" label="发放日期"> </el-table-column>

        <el-table-column prop="give_status" label="发放状态"> </el-table-column>

        <el-table-column prop="status_des" label="进度"> </el-table-column>
        <el-table-column prop="status" label="审核状态"> </el-table-column>

        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <!-- 审核 -->
            <el-button type="primary" size="mini" @click="determine(scope.row)"
              >审核
            </el-button>
          </template>
        </el-table-column>

        <!-- 被拒人员表格 -->
      </el-table>
      <el-table
        v-if="activeName == '2'"
        :data="tableData"
        max-height="500"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="driver_name" label="姓名"> </el-table-column>

        <el-table-column prop="join_stamp" label="报名时间">
          <template slot-scope="scope">
            {{scope.row.join_stamp}}
          </template>
        </el-table-column>

        <el-table-column prop="remarks" label="备注"> </el-table-column>

        <el-table-column prop="operator_name" label="操作人"> </el-table-column>

        <el-table-column prop="time_stamp" label="操作时间"> </el-table-column>
      </el-table>

      <!-- element ui 原生分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search_data_children.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search_data_children.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result_data.count"
        >
        </el-pagination>
      </div>

      <!-- 审核组件 -->
      <toDetermine
        :data="determine_drawer"
        :isShow="determine_isShow"
        @onSubmit="joinTaskDriverList"
      ></toDetermine>
    </div>
  </el-dialog>
</template>

<script>
var _this;
import toDetermine from "./toDetermine.vue";

export default {
  props: {
    isShow: Boolean,
    data: "",
  },

  components: {
    toDetermine,
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;
      _this.search_data_children.task_code = _this.data;

      _this.searchJoinTaskDriverList();
    },
  },
  data() {
    return {
      determine_isShow: false,
      // 传入子组件的数据
      determine_drawer: {},

      // 选项卡默认选中项
      activeName: "1",
      loading: false,

      progress_show: false,
      progress_data: 0,
      result_data: [],

      show: false,

      excelData: [],

      tableData: [],

      //翻页数据
      search_data_children: {
        page: 1,
        limit: 10,
        name: "",
        task_code: "",
        join_status: "1",
   
      },

      search_rules_children: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    searchJoinTaskDriverList() {

      _this.search_data_children.page = 1;
      _this.joinTaskDriverList();
    },
    joinTaskDriverList() {
      _this.tableData = [];
      _this
        .$post(
          "/Offlinepromotion/joinTaskDriverList",
          _this.search_data_children
        )
        .then((res) => {
  
          _this.result_data = res;
          _this.tableData = res.data;
 
        });
    },

    determine(data) {

      _this.determine_isShow = !_this.determine_isShow;
      _this.determine_drawer.status_des = data.status_des;
      _this.determine_drawer.status = data.status;
      _this.determine_drawer.task_code = _this.data;
      _this.determine_drawer.driver_code = data.driver_code;

    },
    // 选项卡选中事件
    handleClick(tab, event) {
      _this.search_data_children.join_status = tab.name;

      _this.searchJoinTaskDriverList();
    },

    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data_children.limit = val;

      //初始化列表
      _this.joinTaskDriverList();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data_children.page = val;

      //初始化列表
      _this.joinTaskDriverList();
    },

    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.activeName = "1";
      _this.search_data_children = {
        page: 1,
        limit: 10,
        task_code: "",
        join_status: "1",
      
      };
    },
    toExport() {
      _this.search_data_children.page = 1;
      _this.search_data_children.limit = 50;

      _this.getExcelData();
    },

    getExcelData() {

      _this
        .$post(
          "/Offlinepromotion/joinTaskDriverList",
          _this.search_data_children
        )
        .then((res) => {
          _this.progress_show = true;

          if (this.$route.path == "/offlinePromotionList") {
            if (this.activeName == 1) {
              // 导出excel的空数组中添加数据
              for (let i = 0; i < res.data.length; i++) {
 

                let reward_monitor, reward_amount, reward_priority_num;
                if (res.data[i].reward_monitor) {
                  reward_monitor = "表现分" + res.data[i].reward_monitor;
                }
                if (res.data[i].reward_amount) {
                  reward_amount = "余额" + res.data[i].reward_amount;
                }
                if (res.data[i].reward_priority_num) {
                  reward_priority_num =
                    "优享券" + res.data[i].reward_priority_num;
                }

     

                _this.excelData.push({
                  driver_name: res.data[i].driver_name,
                  reward:
                    reward_monitor +
                    reward_amount +
                    reward_priority_num,
                  time_stamp: res.data[i].time_stamp,
                  give_stamp: res.data[i].give_stamp,
                  give_status: res.data[i].give_status,
                  status_des: res.data[i].status_des,
                  status: res.data[i].status,
                });
              }
              console.log(_this.excelData,'_this.excelData1');
         
            } else if (this.activeName == 2) {
              // 导出excel的空数组中添加数据
              for (let i = 0; i < res.data.length; i++) {
         
                _this.excelData.push({
                  driver_name: res.data[i].driver_name,

                  join_stamp: res.data[i].join_stamp,
                  remarks: res.data[i].remarks,
                  operator_name: res.data[i].operator_name,
                  time_stamp: res.data[i].time_stamp,
                });
              }
              console.log(_this.excelData,'_this.excelData2');

            }

            if (
              _this.search_data_children.page *
                _this.search_data_children.limit <
              res.count
            ) {
              _this.search_data_children.page =
                _this.search_data_children.page + 1;

              _this.progress_data = Math.floor(
                ((_this.search_data_children.page *
                  _this.search_data_children.limit) /
                  res.count) *
                  100
              );
  

              _this.getExcelData();
            } else {
       

              // 将数据导出execl
              _this.exportData();

              _this.search_data_children.page = 1;
              _this.search_data_children.limit = 10;

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;
              _this.progress_data = 0;
            }
          } else {
            _this.progress_show = false;
            _this.progress_data = 0;
          }
        })
        .catch((err) => {});
    },

    // 导出excel方法
    exportData() {
      const { export_json_to_excel } = require("@/vendor/Export2Excel");

      let tHeader, filterVal;

      if (this.activeName == 1) {
        tHeader = [
          "姓名",
          "奖励",
          "推广日期",
          "发放日期",
          "发放状态",
          "进度",
          "审核状态",
        ];
        filterVal = [
          "driver_name",
          "reward",
          "time_stamp",
          "give_stamp",
          "give_status",
          "status_des",
          "status",
        ];
      } else if (this.activeName == 2) {
        tHeader = ["姓名", "报名时间", "备注", "操作人", "操作时间"];
        filterVal = [
          "driver_name",
          "join_stamp",
          "remarks",
          "operator_name",
          "time_stamp",
        ];
      }

      const list = this.excelData;
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, "线下推广报名人员");
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style scoped>
.search_style {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.driver_water {
  color: #606266;
  margin-bottom: 20px;
}
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.capital-title {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding-bottom: 10px;
  margin-bottom: 10px;
}

h2 {
  font-family: Microsoft YaHei;
  font-weight: 600;
  line-height: 21px;
  color: #222;
  font-size: 18px;
  margin-bottom: 20px;
}

.text {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.text > span {
  margin-right: 10px;
}
.money-box {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.money {
  margin-left: 5px;
}
.orange {
  color: rgb(255, 149, 11);
  font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
  border: 0 !important;
}
.el-date-range-picker__time-header {
  display: block;
}
</style>




